import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8dee03d7c805bcf/components/sections/CtaSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FAQSection"] */ "/tmp/8dee03d7c805bcf/components/sections/FAQSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SolutionsGrid"] */ "/tmp/8dee03d7c805bcf/components/sections/SolutionsGrid.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8dee03d7c805bcf/components/ui/Section.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dee03d7c805bcf/components/ui/Container.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dee03d7c805bcf/components/ui/Heading.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dee03d7c805bcf/components/ui/Text.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dee03d7c805bcf/components/sections/KeyTakeawaysSection.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dee03d7c805bcf/app/[locale]/integrations/[slug]/integration.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dee03d7c805bcf/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/tmp/8dee03d7c805bcf/node_modules/next/dist/client/link.js");
